module.exports = __webpack_public_path__ + "static/img/HOME.d2b652a1.jpg";